export enum ClaimTypeId {
  undef = 0,
  unrecorded = 1,
  wrong_cashback = 2,
  cancelled_purchase = 3,
}
//1 (Μη καταγραφή αγοράς) 2 (Λάθος ποσό επιστροφής) 3 (Ακυρωμένη αγορά)
